<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Usuários Desativados'" :showBtn="true" :btnName="'Voltar'"
                   :btnRoute="'/detalhes-da-empresa/' + this.$route.params.companyId" :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loading"/>

            <!-- Filters -->
            <div v-if="!loading && dataUser.list.length" class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label for="name">Nome</label>
                      <input v-model="dataSearch.name" type="text" class="form-control" id="name" name="name">
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label for="name">CPF</label>
                      <input v-model="dataSearch.cpf" type="text" class="form-control" id="cpf" name="name">
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Quantidade de funcionario</label>
                      <input v-model="dataSearch.qtdEmployer" type="number" class="form-control" placeholder="30">
                    </div>
                  </div>

                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="usersDisabled()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loading && dataUser.list.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="portlet light">
                <div class="portlet-title">
                  <div class="caption">
                    <span class="caption-subject font-blue bold uppercase">Quantidade total de colaboradores desativados ({{
                        dataUser.list.length
                      }})</span>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 padding-null offset-bottom-20 offset-top-10">
                  <div class="checkbox">
                    <input type="checkbox" id="checkbox" v-model="checked" v-on:click="selectAllCheck()">
                    <label
                      v-bind:style="{'font-weight': '600', 'font-size': '13px', 'color': '#93a2a9', 'padding-left': '10px'}"
                      for="checkbox">SELECIONAR TODOS</label>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table cellspacing="0" class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> SELECIONE</th>
                        <th> CÓDIGO</th>
                        <th> NOME</th>
                        <th> EMAIL</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataUser.list">
                        <td>
                          <div class="checkbox">
                            <input v-on:click="addRemoveUser(c)" v-bind:id="c.code" type="checkbox">
                            <label></label>
                          </div>
                        </td>
                        <td>{{ c.code }}</td>
                        <td>{{ c.name }}</td>
                        <td>{{ c.email }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- Box Filter -->
            <div v-if="listFromUser.length" class="container">
              <div class="row">
                <div class="col-md-12 box-content offset-top-20 offset-bottom-40">
                  <!--Info -->
                  <div class="col-md-12">
                    <div class="info-card-blue">
                      <div>1</div>
                      <div>COLABORADORES SELECIONADOS</div>
                      <div>Serão reativados e habilitados para começaram a bater ponto na empresa novamente</div>
                    </div>
                  </div>

                  <!-- List User Selected -->
                  <div class="col-md-12">
                    <div class="col-md-12 box-list-user-selected">
                      <div class="col-md-12 padding-null">
                        <p class="list-user">Lista de funcionários selecionados.
                          <span v-on:click="removeAllUser()" class="remove-all">
                          <span>Remover todos</span>
                          <i class="fa fa-trash" aria-hidden="true"></i>
                        </span>
                        </p>
                      </div>

                      <div v-for="u in listFromUser" class="col-md-3">
                        <div class="user-selected">
                          <span>{{ u.name }}</span>
                          <span v-on:click="removeUserFromCode(u.code)" title="Remover da lista"><i
                            class="icon-close"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Values -->
                  <div class="col-md-12">
                    <form name="form" class="form-filter" novalidate>
                      <!-- Inputs -->
                      <div class="col-md-12 padding-null">
                        <!-- Button Search -->
                        <div class="col-md-12 offset-top-20 offset-bottom-20">
                          <button v-bind:disabled="loading" v-on:click="enableUser()" class="default-btn-bue"
                                  type="button">
                            <div v-if="loading" class="loading-btn">
                              <div class="spinner-btn">
                                <div class="rect1"></div>
                                <div class="rect2"></div>
                                <div class="rect3"></div>
                                <div class="rect4"></div>
                                <div class="rect5"></div>
                              </div>
                            </div>
                            <span v-else>Enviar</span>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import swal from 'sweetalert';

import {
  USERS_DISABLED,
  USERS_ENABLE
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "all-user-disabled",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      checkAll: false,
      checked: false,
      loading: false,
      failRequest: false,
      dataUser: '',
      dataSearch: {
        qtdEmployer: 30,
        name: '',
        cpf: ''
      },
      listFromUser: []
    }
  },
  methods: {
    usersDisabled() {
      this.loading = true;
      let url = USERS_DISABLED + "?companyId=" + this.$route.params.companyId;
      url += "&pageQtd=" + this.dataSearch.qtdEmployer;

      if (this.dataSearch.name)
        url += "&name=" + this.dataSearch.name;

      if (this.dataSearch.cpf)
        url += "&cpf=" + this.dataSearch.cpf;

      REQUEST_SERVICE.get(url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT USERS_DISABLED:", response.data);

          this.dataUser = response.data;
          this.loading = false;
          this.failRequest = false;
        }).catch((reason) => {
        this.loading = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    enableUser() {
      this.loading = true;
      let objSend = {
        c: this.$route.params.companyId,
        usersId: ''
      };

      this.listFromUser.map((value, index) => {
        if (this.listFromUser.length === index + 1) {
          objSend.usersId += value.id;

          UTIL_SERVICE.console("DATA SEND:", objSend);
          REQUEST_SERVICE.get(USERS_ENABLE + "?usersId=" + objSend.usersId).then((response) => {
            UTIL_SERVICE.console("RESULT USERS_ENABLE:", response.data);

            this.loading = false;
            this.$router.push({
              path: '/detalhes-da-empresa/' + this.$route.params.companyId
            });
            swal("Aviso", response.data, "success");
          }).catch((reason) => {
            this.loading = false;
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
        } else {
          objSend.usersId += value.id + ',';
        }
      });
    },
    getIndexesFromList(list) {
      let newList = [];
      for (let i in list) {
        if (typeof list[i].code === "number" && newList.indexOf(list[i].code) === -1)
          newList.push(list[i].code)
      }
      return newList;
    },
    selectAllCheck() {
      this.checked = !this.checked;
      if (this.checked) {
        let indexes = this.getIndexesFromList(this.listFromUser);
        this.dataUser.list.map((value, index) => {
          $("#" + value.code).prop("checked", true);

          if (indexes.indexOf(value.code) === -1) {
            this.listFromUser.push(value);
          }
        });
      } else {
        this.dataUser.list.map((value, index) => {
          this.listFromUser = [];
          $("#" + value.code).prop("checked", false);
        });
      }
    },
    addRemoveUser(c) {
      let obj = {
        id: c.id,
        code: c.code,
        name: c.name
      };
      let indexes = this.getIndexesFromList(this.listFromUser);
      if (indexes.indexOf(obj.code) === -1) {
        this.listFromUser.push(obj);
      } else {
        this.listFromUser.splice(indexes.indexOf(obj.code), 1);
      }
    },
    removeAllUser() {
      this.checked = false;
      this.dataUser.list.map((value, index) => {
        this.listFromUser = [];
        $("#" + value.code).prop("checked", false);
      });
    },
    removeUserFromCode(code) {
      let indexes = this.getIndexesFromList(this.listFromUser);
      this.listFromUser.splice(indexes.indexOf(code), 1);
      $("#" + code).prop("checked", false);
    }
  },
  beforeMount() {
    this.usersDisabled();
  }
}
</script>

<style lang="scss">
.search-employers {
  position: absolute;
  right: 0;
  margin-top: 10px;

  .user-disabled {
    position: absolute;
    top: -55px;
    cursor: pointer;
    color: #837D7D;
    border-bottom: 1px solid #BDB3B3;

    &:hover {
      text-decoration: none;
    }
  }

  label {
    display: block;
    font-weight: 600;
    letter-spacing: 1px;
  }

  input {
    display: inline-block;
    -webkit-border-radius: 4px !important;
    -moz-border-radius: 4px !important;
    border-radius: 4px !important;
    width: 50%;
  }

  button {
    background: #3598DC;
    color: #FFFFFF;
    text-decoration: none;
    margin-right: 30px;
    border-radius: 4px !important;
    border: none;
    font-weight: 600;
    display: inline-block;
    height: 33px;
    line-height: 34px;
    margin-left: 0;
    padding: 0 14px;
  }
}

.checkbox {
  text-align: left;
  margin-left: 30px;
}

.checkbox label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-top: 2px;
  padding-left: 5px;
  top: 0 !important;
}

.checkbox label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  top: 1px;
  left: 0;
  margin-left: -20px;
  border: 1px solid #CCCCCC;
  border-radius: 3px;
  background-color: #FFF;
  -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
}

.checkbox label::after {
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  left: 0;
  top: 0;
  margin-left: -20px;
  padding-left: 3px;
  padding-top: 2px;
  font-size: 14px;
  color: #3598DC;
}

.checkbox input[type="checkbox"] {
  opacity: 0;
  z-index: 1;
  height: 20px;
  width: 20px;
}

.checkbox input[type="checkbox"]:focus + label::before {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

.checkbox input[type="checkbox"]:checked + label::after {
  font-family: "FontAwesome", serif;
  content: "\f00c";
}

.checkbox input[type="checkbox"]:disabled + label {
  opacity: 0.65;
}

.checkbox input[type="checkbox"]:disabled + label::before {
  background-color: #EEEEEE;
  cursor: not-allowed;
}

.checkbox.checkbox-circle label::before {
  border-radius: 50%;
}

.checkbox.checkbox-inline {
  margin-top: 0;
}

.checkbox-info input[type="checkbox"]:checked + label::before {
  background-color: #FFF;
  border-color: #01A0DD;
}

.checkbox-info input[type="checkbox"]:checked + label::after {
  color: #01A0DD;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/companyDetail/allUserDisabled.vue